import { Order } from '@api/types';
import { TextCodes } from '@api/types/translation/TextCodes';
import { ContentBox, ContentBoxItem, SmartLink } from '@components';
import { t } from '@translations/translation';

/**
 * Properties
 */
export type OrderDetailBasicInfoProps = {
  order?: Order;
};

/**
 * Main component for Order Details
 */
export const OrderDetailBasicInfo = ({ order }: OrderDetailBasicInfoProps) => {
  return (
    <ContentBox title={t(TextCodes.Order.Details.OrderInfoHeader)} sx={{ height: '100%' }}>
      {order?.customerName && (
        <ContentBoxItem label={t(TextCodes.Order.Details.CustomerName)}>
          {order?.customerName}
        </ContentBoxItem>
      )}
      {order?.customerEmail && (
        <ContentBoxItem label={t(TextCodes.Order.Details.CustomerEmail)}>
          <SmartLink href={'mailto:' + order?.customerEmail}>{order?.customerEmail}</SmartLink>
        </ContentBoxItem>
      )}
      {order?.deliveryTo && (
        <ContentBoxItem label={t(TextCodes.Order.Details.DeliveryAddress)}>
          {order?.deliveryTo}
        </ContentBoxItem>
      )}
      {order?.deliveryTerms && (
        <ContentBoxItem label={t(TextCodes.Order.Details.DeliveryTerms)}>
          {/* TODO [KF] - confirm delivery terms logic */}
          {order.deliveryTerms}
        </ContentBoxItem>
      )}
    </ContentBox>
  );
};
